import { CREATE_QUESTION_MAP, SET_DISPLAY_QUESTION_MAP } from '../actions/QuestionMapActions';

// INITIALIZE STATE
const initialState = {
    fetching: false,
    fetched: false,
    failed: false,
    displayQuestionMap: localStorage.getItem('displayQuestionMap')
        ? JSON.parse(localStorage.getItem('displayQuestionMap'))
        : true,
    questionMap: null,
};

// REDUCER
export const QuestionMapReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${CREATE_QUESTION_MAP}_PENDING`:
            return {
                ...state,
                questionMap: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${CREATE_QUESTION_MAP}_FULFILLED`:
            return {
                ...state,
                questionMap: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${CREATE_QUESTION_MAP}_REJECTED`:
            return {
                ...state,
                questionMap: null,
                fetching: false,
                fetched: false,
                failed: true,
            };

        case SET_DISPLAY_QUESTION_MAP:
            localStorage.setItem('displayQuestionMap', JSON.stringify(action.payload));

            return {
                ...state,
                displayQuestionMap: action.payload,
            };

        default:
            return state;
    }
};
